'use client'

import Link from 'next/link'
import { useState } from 'react'
import styled from 'styled-components'

import { colors } from '../../../constants/colors'
import { breakpoints } from '../../breakPoints'
import { RightModal } from '../modals/RightModal'
import { MainMenuWindow } from '../modalsContent/MainMenuWindow'
import { ProductSearch } from './ProductSearch'

export const CategoryListHeader = ({ backHref, title }: { backHref: string; title: string }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <>
      <Header>
        <TopRow>
          <BackLink aria-label={'Назад'} href={backHref}>
            <img alt={''} src={'/images/category-header/back.svg'} />
          </BackLink>
          <Title>{title}</Title>
          <MenuButton
            aria-label={'Открыть меню'}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(true)}
            type={'button'}
          >
            <img alt={''} src={'/images/category-header/menu.svg'} />
          </MenuButton>
        </TopRow>
        <ProductSearch compact />
      </Header>
      <RightModal setViewModal={setIsMenuOpen} viewModal={isMenuOpen}>
        <MainMenuWindow handleModalClose={() => setIsMenuOpen(false)} />
      </RightModal>
    </>
  )
}

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin: 24px 0;

  @media (width >= ${breakpoints.productCardsDesktopMin}) {
    display: none;
  }
`

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`

const BackLink = styled(Link)`
  display: flex;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  img {
    width: 24px;
    height: 24px;
  }
`

const Title = styled.h1`
  min-width: 0;
  margin: 0;
  color: #000;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.32;
  text-align: center;
`

const MenuButton = styled.button`
  display: flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: ${colors.lightGray};
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
  }
`
